import copy from 'clipboard-copy';

type CopyPromiseToClipboardOptions = {
  onCopied: () => void;
  onError: (error: unknown) => void;
};

/**
 * Copies asynchronously resolved text while retaining the originating user
 * gesture where the ClipboardItem API supports promise-backed payloads.
 */
export const copyPromiseToClipboard = (
  textPromise: Promise<string>,
  { onCopied, onError }: CopyPromiseToClipboardOptions,
) => {
  const fallbackCopy = async () => {
    try {
      await copy(await textPromise);
      onCopied();
    } catch (error) {
      onError(error);
    }
  };

  if (
    typeof ClipboardItem !== 'undefined' &&
    navigator.clipboard?.write != null
  ) {
    navigator.clipboard
      .write([
        new ClipboardItem({
          'text/plain': textPromise.then(
            text => new Blob([text], { type: 'text/plain' }),
          ),
        }),
      ])
      .then(onCopied)
      .catch(fallbackCopy);
    return;
  }

  void fallbackCopy();
};
